// <auto-generated>
// This file is automatically generated from DSL.
// Do not modify this file directly. Changes will be overwritten.
// Generated: 2026-04-11T10:42:45.816Z
// </auto-generated>

import { AccountBalance, AccountBox, AccountTree, Add, AdminPanelSettings, Approval, Apps, Business, Cable, Category, Dataset, Description, Email, Folder, Groups, Handshake, History, Inbox, Inventory, Inventory2, LocalShipping, MenuBook, Outbox, People, PersonAdd, Place, Policy, Receipt, ReceiptLong, Schedule, Search, Settings, ShoppingCart, SwapHoriz, SyncAlt, TableChart, TaskAlt, TrendingUp, Tune, VpnKey } from '@mui/icons-material';
import { SvgIconComponent } from '@mui/icons-material';

/**
 * Navigation menu item
 */
export interface NavigationMenuItem {
  id: string;
  entity?: string;
  /**
   * Field holding the record's business identity, e.g. 'orderNumber'. Same value the
   * detail view puts in its page heading, so anything labelling a record at runtime
   * shows the identity the user is already looking at.
   */
  displayField?: string;
  viewId?: string;
  label: string;
  labelKey?: string;
  path: string;
  icon?: SvgIconComponent;
  order: number;
  viewType: 'list' | 'inquiry' | 'report' | 'dashboard' | 'form';
  filter?: Record<string, any>;
  permission?: string;
}

/**
 * Navigation category
 */
export interface NavigationCategory {
  id: string;
  label: string;
  labelKey?: string;
  icon: SvgIconComponent;
  order: number;
  items: NavigationMenuItem[];
}

/**
 * Quick action button
 */
export interface QuickAction {
  id: string;
  action: 'create' | 'command';
  label: string;
  labelKey?: string;
  icon: SvgIconComponent;
  path?: string;
  command?: string;
  permission?: string;
}

/**
 * Module navigation configuration
 */
export interface ModuleNavigationConfig {
  module: string;
  label: string;
  labelKey?: string;
  icon: SvgIconComponent;
  quickActions: QuickAction[];
  categories: NavigationCategory[];
}

/**
 * Hierarchical module navigation configuration
 */
export const moduleNavigation: ModuleNavigationConfig[] = [
  {
    module: 'Core',
    label: 'Core',
    labelKey: 'Menu:Core',
    icon: Dataset,
    quickActions: [],
    categories: [
      {
        id: 'records',
        label: 'Masterdata',
        labelKey: 'Menu:Core.Masterdata',
        icon: AccountBox,
        order: 1,
        items: [
        {
          id: 'country',
          entity: 'Country',
          displayField: 'name',
          label: 'Countries',
          labelKey: 'Menu:Core.Country',
          path: '/core/countries',
          order: 50,
          viewType: 'list',
          permission: 'Core.Country.ViewMenu',
        },
        {
          id: 'currency',
          entity: 'Currency',
          displayField: 'name',
          label: 'Currencies',
          labelKey: 'Menu:Core.Currency',
          path: '/core/currencies',
          order: 50,
          viewType: 'list',
          permission: 'Core.Currency.ViewMenu',
        },
        {
          id: 'deliveryterms',
          entity: 'DeliveryTerms',
          displayField: 'name',
          label: 'Delivery Terms',
          labelKey: 'Menu:Core.DeliveryTerms',
          path: '/core/deliveryterms',
          order: 50,
          viewType: 'list',
          permission: 'Core.DeliveryTerms.ViewMenu',
        },
        {
          id: 'enumvalue',
          entity: 'EnumValue',
          displayField: 'displayName',
          label: 'Enum Values',
          labelKey: 'Menu:Core.EnumValue',
          path: '/core/enumvalues',
          order: 50,
          viewType: 'list',
          permission: 'Core.EnumValue.ViewMenu',
        },
        {
          id: 'numberseries',
          entity: 'NumberSeries',
          displayField: 'name',
          label: 'Number Series',
          labelKey: 'Menu:Core.NumberSeries',
          path: '/core/numberseries',
          order: 50,
          viewType: 'list',
          permission: 'Core.NumberSeries.ViewMenu',
        },
        {
          id: 'orgrolefunction',
          entity: 'OrgRoleFunction',
          displayField: 'name',
          label: 'Org Role Functions',
          labelKey: 'Menu:Core.OrgRoleFunction',
          path: '/core/orgrolefunctions',
          order: 50,
          viewType: 'list',
          permission: 'Core.OrgRoleFunction.ViewMenu',
        },
        {
          id: 'paymentterms',
          entity: 'PaymentTerms',
          displayField: 'name',
          label: 'Payment Terms',
          labelKey: 'Menu:Core.PaymentTerms',
          path: '/core/paymentterms',
          order: 50,
          viewType: 'list',
          permission: 'Core.PaymentTerms.ViewMenu',
        },
        {
          id: 'tradetype',
          entity: 'TradeType',
          displayField: 'name',
          label: 'Trade Types',
          labelKey: 'Menu:Core.TradeType',
          path: '/core/tradetypes',
          order: 50,
          viewType: 'list',
          permission: 'Core.TradeType.ViewMenu',
        },
        {
          id: 'unitofmeasure',
          entity: 'UnitOfMeasure',
          displayField: 'name',
          label: 'Unit Of Measures',
          labelKey: 'Menu:Core.UnitOfMeasure',
          path: '/core/unitofmeasures',
          order: 50,
          viewType: 'list',
          permission: 'Core.UnitOfMeasure.ViewMenu',
        },
        {
          id: 'assignmentpolicy',
          entity: 'AssignmentPolicy',
          displayField: 'entityType',
          label: 'Assignment Policies',
          labelKey: 'Menu:Core.AssignmentPolicy',
          path: '/core/assignmentpolicies',
          icon: Description,
          order: 280,
          viewType: 'list',
          permission: 'Core.AssignmentPolicy.ViewMenu',
        }
        ],
      },
      {
        id: 'configuration',
        label: 'Configuration',
        labelKey: 'Menu:Core.Configuration',
        icon: Tune,
        order: 2,
        items: [
        {
          id: 'orgunit',
          entity: 'OrgUnit',
          displayField: 'name',
          label: 'Organization',
          labelKey: 'Menu:Core.OrgUnit',
          path: '/core/organization',
          icon: AccountTree,
          order: 5,
          viewType: 'list',
          permission: 'Core.OrgUnit.ViewMenu',
        },
        {
          id: 'entitytemplate',
          entity: 'EntityTemplate',
          displayField: 'entityName',
          label: 'Entity Templates',
          labelKey: 'Menu:Core.EntityTemplate',
          path: '/core/entitytemplates',
          icon: Description,
          order: 90,
          viewType: 'list',
          permission: 'Core.EntityTemplate.ViewMenu',
        },
        {
          id: 'setuppackage',
          entity: 'SetupPackage',
          displayField: 'moduleName',
          label: 'Setup Packages',
          labelKey: 'Menu:Core.SetupPackage',
          path: '/core/setuppackages',
          icon: Inventory2,
          order: 95,
          viewType: 'list',
          permission: 'Core.SetupPackage.ViewMenu',
        }
        ],
      },
      {
        id: 'administration',
        label: 'Administration',
        labelKey: 'Menu:Core.Administration',
        icon: Folder,
        order: 50,
        items: [
        {
          id: 'batchjob',
          entity: 'BatchJob',
          displayField: 'name',
          label: 'Batch Jobs',
          labelKey: 'Menu:Core.BatchJob',
          path: '/core/batchjobs',
          icon: Schedule,
          order: 50,
          viewType: 'list',
          permission: 'Core.BatchJob.ViewMenu',
        }
        ],
      },
      {
        id: 'setup',
        label: 'Setup',
        labelKey: 'Menu:Core.Setup',
        icon: Folder,
        order: 50,
        items: [
        {
          id: 'ownerderivationrule',
          entity: 'OwnerDerivationRule',
          displayField: 'entityType',
          label: 'Owner Derivation Rules',
          labelKey: 'Menu:Core.OwnerDerivationRule',
          path: '/core/ownerderivationrules',
          icon: Description,
          order: 20,
          viewType: 'list',
          permission: 'Core.OwnerDerivationRule.ViewMenu',
        }
        ],
      },
      {
        id: 'settings',
        label: 'Settings',
        labelKey: 'Menu:Core.Settings',
        icon: Settings,
        order: 99,
        items: [
        {
          id: 'orgunit_list',
          entity: 'OrgUnit',
          displayField: 'name',
          label: 'Org Units (Admin)',
          labelKey: 'Menu:Core.OrgUnits(Admin)',
          path: '/core/orgunits',
          icon: Business,
          order: 5,
          viewType: 'list',
          permission: 'Core.OrgUnit.Update',
        },
        {
          id: 'companyprofile',
          entity: 'CompanyProfile',
          displayField: 'orgNumber',
          label: 'Company Details',
          labelKey: 'Menu:Core.CompanyProfile',
          path: '/core/companyprofiles',
          order: 45,
          viewType: 'list',
          permission: 'Core.CompanyProfile.ViewMenu',
        },
        {
          id: 'documenttemplate',
          entity: 'DocumentTemplate',
          displayField: 'name',
          label: 'Document Templates',
          labelKey: 'Menu:Core.DocumentTemplate',
          path: '/core/documenttemplates',
          order: 50,
          viewType: 'list',
          permission: 'Core.DocumentTemplate.ViewMenu',
        },
        {
          id: 'documentpagesetup',
          entity: 'DocumentPageSetup',
          displayField: 'name',
          label: 'Document Page Setups',
          labelKey: 'Menu:Core.DocumentPageSetup',
          path: '/core/documentpagesetups',
          order: 51,
          viewType: 'list',
          permission: 'Core.DocumentPageSetup.ViewMenu',
        }
        ],
      }
    ],
  },
  {
    module: 'Finance',
    label: 'Finance',
    labelKey: 'Menu:Finance',
    icon: AccountBalance,
    quickActions: [],
    categories: [
      {
        id: 'records',
        label: 'General Ledger',
        labelKey: 'Menu:Finance.GeneralLedger',
        icon: MenuBook,
        order: 1,
        items: [
        {
          id: 'account',
          entity: 'Account',
          displayField: 'accountNumber',
          label: 'Accounts',
          labelKey: 'Menu:Finance.Account',
          path: '/finance/accounts',
          icon: Description,
          order: 10,
          viewType: 'list',
          permission: 'Finance.Account.ViewMenu',
        },
        {
          id: 'hierarchy_financeaccountgroup',
          entity: 'FinanceAccountGroup',
          label: 'Account Groups',
          labelKey: 'Menu:Finance.AccountGroups',
          path: '/finance/financeaccountgroups',
          icon: AccountTree,
          order: 20,
          viewType: 'list',
          permission: 'Finance.FinanceAccountGroup.ViewMenu',
        },
        {
          id: 'vatcode',
          entity: 'VatCode',
          displayField: 'name',
          label: 'VAT Codes',
          labelKey: 'Menu:Finance.VatCode',
          path: '/finance/vatcodes',
          icon: Description,
          order: 30,
          viewType: 'list',
          permission: 'Finance.VatCode.ViewMenu',
        },
        {
          id: 'fiscalyear',
          entity: 'FiscalYear',
          displayField: 'name',
          label: 'Fiscal Years',
          labelKey: 'Menu:Finance.FiscalYear',
          path: '/finance/fiscalyears',
          icon: Description,
          order: 40,
          viewType: 'list',
          permission: 'Finance.FiscalYear.ViewMenu',
        },
        {
          id: 'dimensionset',
          entity: 'DimensionSet',
          displayField: 'hash',
          label: 'Dimension Sets',
          labelKey: 'Menu:Finance.DimensionSet',
          path: '/finance/dimensionsets',
          order: 50,
          viewType: 'list',
          permission: 'Finance.DimensionSet.ViewMenu',
        },
        {
          id: 'fiscalperiod',
          entity: 'FiscalPeriod',
          displayField: 'name',
          label: 'Fiscal Periods',
          labelKey: 'Menu:Finance.FiscalPeriod',
          path: '/finance/fiscalperiods',
          icon: Description,
          order: 50,
          viewType: 'list',
          permission: 'Finance.FiscalPeriod.ViewMenu',
        }
        ],
      },
      {
        id: 'budget',
        label: 'Budget & Planning',
        labelKey: 'Menu:Finance.Budget&Planning',
        icon: TrendingUp,
        order: 2,
        items: [
        {
          id: 'planscenario',
          entity: 'PlanScenario',
          displayField: 'name',
          label: 'Plan Scenarios',
          labelKey: 'Menu:Finance.PlanScenario',
          path: '/finance/planscenarios',
          icon: Description,
          order: 40,
          viewType: 'list',
          permission: 'Finance.PlanScenario.ViewMenu',
        },
        {
          id: 'planversion',
          entity: 'PlanVersion',
          displayField: 'label',
          label: 'Plan Versions',
          labelKey: 'Menu:Finance.PlanVersion',
          path: '/finance/planversions',
          icon: Description,
          order: 50,
          viewType: 'list',
          permission: 'Finance.PlanVersion.ViewMenu',
        },
        {
          id: 'planheader',
          entity: 'PlanHeader',
          displayField: 'name',
          label: 'Plan Headers',
          labelKey: 'Menu:Finance.PlanHeader',
          path: '/finance/planheaders',
          icon: Description,
          order: 52,
          viewType: 'list',
          permission: 'Finance.PlanHeader.ViewMenu',
        },
        {
          id: 'planversionpublishrun',
          entity: 'PlanVersionPublishRun',
          displayField: 'correlationId',
          label: 'Plan Publish Runs',
          labelKey: 'Menu:Finance.PlanVersionPublishRun',
          path: '/finance/planversionpublishruns',
          icon: History,
          order: 55,
          viewType: 'list',
          permission: 'Finance.PlanVersionPublishRun.ViewMenu',
        },
        {
          id: 'planlinereevaluationrun',
          entity: 'PlanLineReevaluationRun',
          displayField: 'runNumber',
          label: 'Plan Re-evaluation Runs',
          labelKey: 'Menu:Finance.PlanLineReevaluationRun',
          path: '/finance/planlinereevaluationruns',
          icon: History,
          order: 56,
          viewType: 'list',
          permission: 'Finance.PlanLineReevaluationRun.ViewMenu',
        },
        {
          id: 'planline',
          entity: 'PlanLine',
          displayField: 'notes',
          label: 'Plan Lines',
          labelKey: 'Menu:Finance.PlanLine',
          path: '/finance/planlines',
          icon: Description,
          order: 60,
          viewType: 'list',
          permission: 'Finance.PlanLine.ViewMenu',
        },
        {
          id: 'planview',
          entity: 'PlanView',
          displayField: 'name',
          label: 'Plan Views',
          labelKey: 'Menu:Finance.PlanView',
          path: '/finance/planviews',
          icon: Description,
          order: 70,
          viewType: 'list',
          permission: 'Finance.PlanView.ViewMenu',
        },
        {
          id: 'planstatementtemplate',
          entity: 'PlanStatementTemplate',
          displayField: 'name',
          label: 'Report Templates',
          labelKey: 'Menu:Finance.PlanStatementTemplate',
          path: '/finance/planstatementtemplates',
          icon: Description,
          order: 71,
          viewType: 'list',
          permission: 'Finance.PlanStatementTemplate.ViewMenu',
        },
        {
          id: 'distributionprofile',
          entity: 'DistributionProfile',
          displayField: 'name',
          label: 'Distribution Profiles',
          labelKey: 'Menu:Finance.DistributionProfile',
          path: '/finance/distributionprofiles',
          icon: Description,
          order: 80,
          viewType: 'list',
          permission: 'Finance.DistributionProfile.ViewMenu',
        },
        {
          id: 'accountderivationrule',
          entity: 'AccountDerivationRule',
          displayField: 'notes',
          label: 'Account Derivation Rules',
          labelKey: 'Menu:Finance.AccountDerivationRule',
          path: '/finance/accountderivationrules',
          icon: Description,
          order: 100,
          viewType: 'list',
          permission: 'Finance.AccountDerivationRule.ViewMenu',
        }
        ],
      },
      {
        id: 'dimensions',
        label: 'Dimensions',
        labelKey: 'Menu:Finance.Dimensions',
        icon: Tune,
        order: 3,
        items: [
        {
          id: 'dimensiondefinition',
          entity: 'DimensionDefinition',
          displayField: 'name',
          label: 'Dimension Definitions',
          labelKey: 'Menu:Finance.DimensionDefinition',
          path: '/finance/dimensiondefinitions',
          icon: Description,
          order: 10,
          viewType: 'list',
          permission: 'Finance.DimensionDefinition.ViewMenu',
        },
        {
          id: 'dimensionvalue',
          entity: 'DimensionValue',
          displayField: 'name',
          label: 'Dimension Values',
          labelKey: 'Menu:Finance.DimensionValue',
          path: '/finance/dimensionvalues',
          icon: Description,
          order: 20,
          viewType: 'list',
          permission: 'Finance.DimensionValue.ViewMenu',
        },
        {
          id: 'accountdimensionrule',
          entity: 'AccountDimensionRule',
          displayField: 'id',
          label: 'Account Dimension Rules',
          labelKey: 'Menu:Finance.AccountDimensionRule',
          path: '/finance/accountdimensionrules',
          icon: Description,
          order: 30,
          viewType: 'list',
          permission: 'Finance.AccountDimensionRule.ViewMenu',
        }
        ],
      }
    ],
  },
  {
    module: 'Integration',
    label: 'Integration',
    labelKey: 'Menu:Integration',
    icon: SyncAlt,
    quickActions: [],
    categories: [
      {
        id: 'messages',
        label: 'Messages',
        labelKey: 'Menu:Integration.Messages',
        icon: Email,
        order: 1,
        items: [
        {
          id: 'integrationstagingrecord',
          entity: 'IntegrationStagingRecord',
          displayField: 'originalFileName',
          label: 'Inbound Messages',
          labelKey: 'Menu:Integration.IntegrationStagingRecord',
          path: '/integration/integrationstagingrecords',
          icon: Inbox,
          order: 10,
          viewType: 'list',
          permission: 'Integration.IntegrationStagingRecord.ViewMenu',
        },
        {
          id: 'integrationoutboxrecord',
          entity: 'IntegrationOutboxRecord',
          displayField: 'originalFileName',
          label: 'Outbound Messages',
          labelKey: 'Menu:Integration.IntegrationOutboxRecord',
          path: '/integration/integrationoutboxrecords',
          icon: Outbox,
          order: 20,
          viewType: 'list',
          permission: 'Integration.IntegrationOutboxRecord.ViewMenu',
        }
        ],
      },
      {
        id: 'administration',
        label: 'Administration',
        labelKey: 'Menu:Integration.Administration',
        icon: Folder,
        order: 50,
        items: [
        {
          id: 'integrationconnection',
          entity: 'IntegrationConnection',
          displayField: 'name',
          label: 'Integration Connections',
          labelKey: 'Menu:Integration.IntegrationConnection',
          path: '/integration/integrationconnections',
          icon: Cable,
          order: 30,
          viewType: 'list',
          permission: 'Integration.IntegrationConnection.ViewMenu',
        },
        {
          id: 'integrationjob',
          entity: 'IntegrationJob',
          displayField: 'name',
          label: 'Integration Jobs',
          labelKey: 'Menu:Integration.IntegrationJob',
          path: '/integration/integrationjobs',
          icon: SyncAlt,
          order: 31,
          viewType: 'list',
          permission: 'Integration.IntegrationJob.ViewMenu',
        },
        {
          id: 'importprofile',
          entity: 'ImportProfile',
          displayField: 'name',
          label: 'Import Profiles',
          labelKey: 'Menu:Integration.ImportProfile',
          path: '/integration/importprofiles',
          icon: TableChart,
          order: 32,
          viewType: 'list',
          permission: 'Integration.ImportProfile.ViewMenu',
        },
        {
          id: 'integrationclient',
          entity: 'IntegrationClient',
          displayField: 'name',
          label: 'Integration Clients',
          labelKey: 'Menu:Integration.IntegrationClient',
          path: '/integration/integrationclients',
          icon: VpnKey,
          order: 32,
          viewType: 'list',
          permission: 'Integration.IntegrationClient.ViewMenu',
        },
        {
          id: 'integrationrun',
          entity: 'IntegrationRun',
          displayField: 'commandMode',
          label: 'Integration Runs',
          labelKey: 'Menu:Integration.IntegrationRun',
          path: '/integration/integrationruns',
          icon: History,
          order: 35,
          viewType: 'list',
          permission: 'Integration.IntegrationRun.ViewMenu',
        }
        ],
      },
      {
        id: 'settings',
        label: 'Settings',
        labelKey: 'Menu:Integration.Settings',
        icon: Settings,
        order: 99,
        items: [

        ],
      }
    ],
  },
  {
    module: 'Inventory',
    label: 'Inventory',
    labelKey: 'Menu:Inventory',
    icon: Inventory,
    quickActions: [
      {
        id: 'product_create',
        action: 'create',
        label: 'New Stock Item',
        labelKey: 'QuickAction:Product.create',
        icon: Add,
        path: '/inventory/products/new',
        permission: 'Inventory.Product.Create',
      }
    ],
    categories: [
      {
        id: 'transactions',
        label: 'Transactions',
        labelKey: 'Menu:Inventory.Transactions',
        icon: SwapHoriz,
        order: 1,
        items: [
        {
          id: 'inventorytransaction',
          entity: 'InventoryTransaction',
          displayField: 'locationCode',
          label: 'Inventory Transactions',
          labelKey: 'Menu:Inventory.InventoryTransaction',
          path: '/inventory/inventorytransactions',
          order: 20,
          viewType: 'list',
          permission: 'Inventory.InventoryTransaction.ViewMenu',
        },
        {
          id: 'inventoryreservation',
          entity: 'InventoryReservation',
          displayField: 'sourceId',
          label: 'Reservations',
          labelKey: 'Menu:Inventory.InventoryReservation',
          path: '/inventory/inventoryreservations',
          order: 30,
          viewType: 'list',
          permission: 'Inventory.InventoryReservation.ViewMenu',
        }
        ],
      },
      {
        id: 'records',
        label: 'Masterdata',
        labelKey: 'Menu:Inventory.Masterdata',
        icon: AccountBox,
        order: 2,
        items: [
        {
          id: 'product',
          entity: 'Product',
          displayField: 'productNumber',
          label: 'Stock Items',
          labelKey: 'Menu:Inventory.Product',
          path: '/inventory/products',
          icon: Category,
          order: 10,
          viewType: 'list',
          permission: 'Inventory.Product.ViewMenu',
        },
        {
          id: 'hierarchy_inventoryproductgroup',
          entity: 'InventoryProductGroup',
          label: 'Product Groups',
          labelKey: 'Menu:Inventory.ProductGroups',
          path: '/inventory/inventoryproductgroups',
          icon: Category,
          order: 25,
          viewType: 'list',
          permission: 'Inventory.InventoryProductGroup.ViewMenu',
        }
        ],
      },
      {
        id: 'inquiries',
        label: 'Inquiries',
        labelKey: 'Menu:Inventory.Inquiries',
        icon: Search,
        order: 5,
        items: [
        {
          id: 'product_inquiry',
          entity: 'Product',
          displayField: 'productNumber',
          label: 'Item Availability',
          labelKey: 'Menu:Inventory.ItemAvailability',
          path: '/inventory/products',
          order: 10,
          viewType: 'inquiry',
          permission: 'Inventory.Product.ViewMenu',
        }
        ],
      },
      {
        id: 'processes',
        label: 'Processes',
        labelKey: 'Menu:Inventory.Processes',
        icon: AccountTree,
        order: 7,
        items: [
        {
          id: 'inventoryperiodclose',
          entity: 'InventoryPeriodClose',
          displayField: 'period',
          label: 'Period Close',
          labelKey: 'Menu:Inventory.InventoryPeriodClose',
          path: '/inventory/inventoryperiodcloses',
          order: 10,
          viewType: 'list',
          permission: 'Inventory.InventoryPeriodClose.ViewMenu',
        }
        ],
      },
      {
        id: 'settings',
        label: 'Settings',
        labelKey: 'Menu:Inventory.Settings',
        icon: Settings,
        order: 99,
        items: [
        {
          id: 'inventorypostingprofile',
          entity: 'InventoryPostingProfile',
          displayField: 'accountCode',
          label: 'Posting Profiles',
          labelKey: 'Menu:Inventory.InventoryPostingProfile',
          path: '/inventory/inventorypostingprofiles',
          order: 20,
          viewType: 'list',
          permission: 'Inventory.InventoryPostingProfile.ViewMenu',
        },
        {
          id: 'standardcostversion',
          entity: 'StandardCostVersion',
          displayField: 'versionCode',
          label: 'Standard Cost Versions',
          labelKey: 'Menu:Inventory.StandardCostVersion',
          path: '/inventory/standardcostversions',
          order: 30,
          viewType: 'list',
          permission: 'Inventory.StandardCostVersion.ViewMenu',
        }
        ],
      }
    ],
  },
  {
    module: 'Pricing',
    label: 'Pricing',
    labelKey: 'Menu:Pricing',
    icon: Apps,
    quickActions: [],
    categories: [
      {
        id: 'records',
        label: 'Masterdata',
        labelKey: 'Menu:Pricing.Masterdata',
        icon: AccountBox,
        order: 1,
        items: [
        {
          id: 'pricelist',
          entity: 'PriceList',
          displayField: 'name',
          label: 'Price Lists',
          labelKey: 'Menu:Pricing.PriceList',
          path: '/pricing/pricelists',
          order: 40,
          viewType: 'list',
          permission: 'Pricing.PriceList.ViewMenu',
        },
        {
          id: 'internalpricelist',
          entity: 'InternalPriceList',
          displayField: 'name',
          label: 'Internal Price Lists',
          labelKey: 'Menu:Pricing.InternalPriceList',
          path: '/pricing/internalpricelists',
          order: 41,
          viewType: 'list',
          permission: 'Pricing.InternalPriceList.ViewMenu',
        }
        ],
      },
      {
        id: 'settings',
        label: 'Settings',
        labelKey: 'Menu:Pricing.Settings',
        icon: Settings,
        order: 99,
        items: [

        ],
      }
    ],
  },
  {
    module: 'Procurement',
    label: 'Procurement',
    labelKey: 'Menu:Procurement',
    icon: Receipt,
    quickActions: [
      {
        id: 'agreement_create',
        action: 'create',
        label: 'New Agreement',
        labelKey: 'QuickAction:Agreement.create',
        icon: Add,
        path: '/procurement/agreements/new',
        permission: 'Procurement.Agreement.Create',
      },
      {
        id: 'organization_create',
        action: 'create',
        label: 'New Organization',
        labelKey: 'QuickAction:Organization.create',
        icon: Add,
        path: '/procurement/organizations/new',
        permission: 'Procurement.Organization.Create',
      },
      {
        id: 'project_create',
        action: 'create',
        label: 'New Project',
        labelKey: 'QuickAction:Project.create',
        icon: Add,
        path: '/procurement/projects/new',
        permission: 'Procurement.Project.Create',
      },
      {
        id: 'supplier_create',
        action: 'create',
        label: 'New Supplier',
        labelKey: 'QuickAction:Supplier.create',
        icon: Add,
        path: '/procurement/suppliers/new',
        permission: 'Procurement.Supplier.Create',
      },
      {
        id: 'workorder_create',
        action: 'create',
        label: 'New Workorder',
        labelKey: 'QuickAction:Workorder.create',
        icon: Add,
        path: '/procurement/workorders/new',
        permission: 'Procurement.Workorder.Create',
      }
    ],
    categories: [
      {
        id: 'records',
        label: 'Masterdata',
        labelKey: 'Menu:Procurement.Masterdata',
        icon: AccountBox,
        order: 1,
        items: [
        {
          id: 'agreement',
          entity: 'Agreement',
          displayField: 'agreementNumber',
          label: 'Agreements',
          labelKey: 'Menu:Procurement.Agreement',
          path: '/procurement/agreements',
          icon: Description,
          order: 50,
          viewType: 'list',
          permission: 'Procurement.Agreement.ViewMenu',
        },
        {
          id: 'organization',
          entity: 'Organization',
          displayField: 'name',
          label: 'Organizations',
          labelKey: 'Menu:Procurement.Organization',
          path: '/procurement/organizations',
          icon: Description,
          order: 50,
          viewType: 'list',
          permission: 'Procurement.Organization.ViewMenu',
        },
        {
          id: 'project',
          entity: 'Project',
          displayField: 'projectId',
          label: 'Projects',
          labelKey: 'Menu:Procurement.Project',
          path: '/procurement/projects',
          icon: Description,
          order: 50,
          viewType: 'list',
          permission: 'Procurement.Project.ViewMenu',
        },
        {
          id: 'workorder',
          entity: 'Workorder',
          displayField: 'workorderNumber',
          label: 'Workorders',
          labelKey: 'Menu:Procurement.Workorder',
          path: '/procurement/workorders',
          icon: ShoppingCart,
          order: 50,
          viewType: 'list',
          permission: 'Procurement.Workorder.ViewMenu',
        },
        {
          id: 'supplier',
          entity: 'Supplier',
          displayField: 'supplierNumber',
          label: 'Suppliers',
          labelKey: 'Menu:Procurement.Supplier',
          path: '/procurement/suppliers',
          icon: LocalShipping,
          order: 55,
          viewType: 'list',
          permission: 'Procurement.Supplier.ViewMenu',
        }
        ],
      },
      {
        id: 'transactions',
        label: 'Transactions',
        labelKey: 'Menu:Procurement.Transactions',
        icon: SwapHoriz,
        order: 50,
        items: [
        {
          id: 'loadobservation',
          entity: 'LoadObservation',
          displayField: 'id',
          label: 'Load observations',
          labelKey: 'Menu:Procurement.LoadObservation',
          path: '/procurement/loadobservations',
          icon: Place,
          order: 50,
          viewType: 'list',
          permission: 'Procurement.LoadObservation.ViewMenu',
        },
        {
          id: 'inboundmeasuringticket',
          entity: 'InboundMeasuringTicket',
          displayField: 'measuringTicketNumber',
          label: 'Inbound Measuring Tickets',
          labelKey: 'Menu:Procurement.InboundMeasuringTicket',
          path: '/procurement/inboundmeasuringtickets',
          icon: ReceiptLong,
          order: 60,
          viewType: 'list',
          permission: 'Procurement.InboundMeasuringTicket.ViewMenu',
        }
        ],
      },
      {
        id: 'settings',
        label: 'Settings',
        labelKey: 'Menu:Procurement.Settings',
        icon: Settings,
        order: 99,
        items: [

        ],
      }
    ],
  },
  {
    module: 'Sales',
    label: 'Sales',
    labelKey: 'Menu:Sales',
    icon: Handshake,
    quickActions: [
      {
        id: 'customer_create',
        action: 'create',
        label: 'New Customer',
        labelKey: 'QuickAction:Customer.create',
        icon: PersonAdd,
        path: '/sales/customers/new',
        permission: 'Sales.Customer.Create',
      },
      {
        id: 'customergroup_create',
        action: 'create',
        label: 'New Customer Group',
        labelKey: 'QuickAction:CustomerGroup.create',
        icon: Add,
        path: '/sales/customergroups/new',
        permission: 'Sales.CustomerGroup.Create',
      },
      {
        id: 'order_create',
        action: 'create',
        label: 'New Order',
        labelKey: 'QuickAction:Order.create',
        icon: Add,
        path: '/sales/orders/new',
        permission: 'Sales.Order.Create',
      }
    ],
    categories: [
      {
        id: 'transactions',
        label: 'Transactions',
        labelKey: 'Menu:Sales.Transactions',
        icon: SwapHoriz,
        order: 1,
        items: [
        {
          id: 'order',
          entity: 'Order',
          displayField: 'orderNumber',
          label: 'Orders',
          labelKey: 'Menu:Sales.Order',
          path: '/sales/orders',
          icon: ShoppingCart,
          order: 10,
          viewType: 'list',
          permission: 'Sales.Order.ViewMenu',
        },
        {
          id: 'invoice',
          entity: 'Invoice',
          displayField: 'invoiceNumber',
          label: 'Invoices',
          labelKey: 'Menu:Sales.Invoice',
          path: '/sales/invoices',
          order: 20,
          viewType: 'list',
          permission: 'Sales.Invoice.ViewMenu',
        }
        ],
      },
      {
        id: 'records',
        label: 'Masterdata',
        labelKey: 'Menu:Sales.Masterdata',
        icon: AccountBox,
        order: 2,
        items: [
        {
          id: 'customer',
          entity: 'Customer',
          displayField: 'customerNumber',
          label: 'Customers',
          labelKey: 'Menu:Sales.Customer',
          path: '/sales/customers',
          icon: People,
          order: 10,
          viewType: 'list',
          permission: 'Sales.Customer.ViewMenu',
        },
        {
          id: 'customergroup',
          entity: 'CustomerGroup',
          displayField: 'name',
          label: 'Customer Groups',
          labelKey: 'Menu:Sales.CustomerGroup',
          path: '/sales/customergroups',
          icon: Groups,
          order: 12,
          viewType: 'list',
          permission: 'Sales.CustomerGroup.ViewMenu',
        }
        ],
      },
      {
        id: 'inquiries',
        label: 'Inquiries',
        labelKey: 'Menu:Sales.Inquiries',
        icon: Search,
        order: 3,
        items: [
        {
          id: 'order_inquiry',
          entity: 'Order',
          displayField: 'orderNumber',
          label: 'Order History',
          labelKey: 'Menu:Sales.OrderHistory',
          path: '/sales/orders?preset=last30Days',
          order: 10,
          viewType: 'inquiry',
          permission: 'Sales.Order.ViewMenu',
        }
        ],
      },
      {
        id: 'settings',
        label: 'Settings',
        labelKey: 'Menu:Sales.Settings',
        icon: Settings,
        order: 99,
        items: [

        ],
      }
    ],
  },
  {
    module: 'TaskManagement',
    label: 'TaskManagement',
    labelKey: 'Menu:TaskManagement',
    icon: TaskAlt,
    quickActions: [],
    categories: [
      {
        id: 'workflow',
        label: 'Workflow',
        labelKey: 'Menu:TaskManagement.Workflow',
        icon: AccountTree,
        order: 1,
        items: [
        {
          id: 'worktask',
          entity: 'WorkTask',
          displayField: 'workflowName',
          label: 'Task Inbox',
          labelKey: 'Menu:TaskManagement.WorkTask',
          path: '/taskmanagement/inbox',
          icon: Inbox,
          order: 10,
          viewType: 'list',
          permission: 'TaskManagement.WorkTask.ViewMenu',
        }
        ],
      },
      {
        id: 'settings',
        label: 'Settings',
        labelKey: 'Menu:TaskManagement.Settings',
        icon: Settings,
        order: 99,
        items: [
        {
          id: 'worktask_list',
          entity: 'WorkTask',
          displayField: 'workflowName',
          label: 'Work Tasks (Admin)',
          labelKey: 'Menu:TaskManagement.WorkTasks(Admin)',
          path: '/taskmanagement/worktasks',
          icon: AdminPanelSettings,
          order: 10,
          viewType: 'list',
          permission: 'TaskManagement.WorkTask.Update',
        }
        ],
      }
    ],
  },
  {
    module: 'Workflow',
    label: 'Workflow',
    labelKey: 'Menu:Workflow',
    icon: AccountTree,
    quickActions: [],
    categories: [
      {
        id: 'workflow',
        label: 'Workflow',
        labelKey: 'Menu:Workflow.Workflow',
        icon: Folder,
        order: 50,
        items: [
        {
          id: 'approvalrequest',
          entity: 'ApprovalRequest',
          displayField: 'requestNumber',
          label: 'Approval Requests',
          labelKey: 'Menu:Workflow.ApprovalRequest',
          path: '/workflow/approvalrequests',
          icon: Approval,
          order: 10,
          viewType: 'list',
          permission: 'Workflow.ApprovalRequest.ViewMenu',
        },
        {
          id: 'approvalpolicy',
          entity: 'ApprovalPolicy',
          displayField: 'name',
          label: 'Approval Policies',
          labelKey: 'Menu:Workflow.ApprovalPolicy',
          path: '/workflow/approvalpolicies',
          icon: Policy,
          order: 20,
          viewType: 'list',
          permission: 'Workflow.ApprovalPolicy.ViewMenu',
        },
        {
          id: 'approvaldelegation',
          entity: 'ApprovalDelegation',
          displayField: 'fromUserName',
          label: 'Delegations',
          labelKey: 'Menu:Workflow.ApprovalDelegation',
          path: '/workflow/approvaldelegations',
          icon: SwapHoriz,
          order: 30,
          viewType: 'list',
          permission: 'Workflow.ApprovalDelegation.ViewMenu',
        }
        ],
      },
      {
        id: 'settings',
        label: 'Settings',
        labelKey: 'Menu:Workflow.Settings',
        icon: Settings,
        order: 99,
        items: [

        ],
      }
    ],
  }
];

/**
 * Get navigation for a specific module
 */
export function getModuleNavigation(moduleName: string): ModuleNavigationConfig | undefined {
  return moduleNavigation.find(m => m.module === moduleName);
}

/**
 * Get all module names
 */
export function getAllModules(): string[] {
  return moduleNavigation.map(m => m.module);
}

/**
 * Get all navigation items for a module (flattened)
 */
export function getModuleItems(moduleName: string): NavigationMenuItem[] {
  const module = getModuleNavigation(moduleName);
  if (!module) return [];

  return module.categories.flatMap(cat => cat.items);
}

/**
 * Find a navigation item by path
 */
export function findItemByPath(path: string): NavigationMenuItem | undefined {
  for (const module of moduleNavigation) {
    for (const category of module.categories) {
      const item = category.items.find(i => i.path === path);
      if (item) return item;
    }
  }
  return undefined;
}
